import AttributeDetails from '@atom/components/common/attributeDetails/AttributeDetails';
import { AttributeView } from '@atom/components/common/attributeDetails/AttributeDetailsContext';
import { Icon } from '@atom/mui';
import { EditIcon, LocationOnIcon, WorkIcon } from '@atom/mui/icons';
import { AssetDetail } from '@atom/types/asset';
import { PolicyAction } from '@atom/types/policy';
import { AttributesType } from '@atom/types/schema';
import { hasAccess } from '@atom/utilities/accessUtilities';
import textDisplayUtilities from '@atom/utilities/textDisplayUtilities';
import timeUtilities from '@atom/utilities/timeUtilities';

import { getGoogleShapeCenter } from '../../mapUtilities';

import { AttributesSavePayload } from './useAssetSidebarData';

import sidebarClasses from '../shared/sidebars.module.css';
import classes from './asset.module.css';

export type AssetInfoTabProps = {
  asset: AssetDetail;
  attributeLoading: string[];
  onAttributesPendingChange: (
    action: string,
    attributeGroupName: string,
    attribute: AttributesType,
  ) => Promise<void>;
  onAttributesSave: (payload: AttributesSavePayload) => Promise<void>;
};

const AssetInfoTab = ({
  asset,
  attributeLoading,
  onAttributesPendingChange,
  onAttributesSave,
}: AssetInfoTabProps) => {
  const center = getGoogleShapeCenter(asset.location);
  const lat = textDisplayUtilities.latLong(center.lat);
  const lng = textDisplayUtilities.latLong(center.lng);

  const lastWorkOrderName = asset.lastWorkOrder?.name ?? '-';
  const lastWorkOrderUpdatedDate = asset.lastWorkOrder?.updatedDate
    ? timeUtilities.setDisplayDate(asset.lastWorkOrder.updatedDate)
    : '-';

  const canUpdate = hasAccess(PolicyAction.UPDATE, asset.actions);
  const canManageChanges = hasAccess(
    PolicyAction.MANAGE_INVENTORY_CHANGES,
    asset.actions,
  );

  return (
    <div className={sidebarClasses.infoPanel}>
      <div className={classes.basicInfo}>
        <div className={classes.basicInfoRow}>
          <Icon icon={LocationOnIcon} />
          <div>
            <div className={classes.basicInfoMain}>{asset.address}</div>
            <div className={classes.basicInfoSub}>{`${lat}, ${lng}`}</div>
          </div>
        </div>
        <div className={classes.basicInfoRow}>
          <Icon icon={EditIcon} />
          <div>
            <div className={classes.basicInfoMain}>
              {timeUtilities.setDisplayDate(asset.updatedDate)}
            </div>
            <div className={classes.basicInfoSub}>Last Updated</div>
          </div>
        </div>
        <div className={classes.basicInfoRow}>
          <Icon icon={WorkIcon} />
          <div>
            <div
              className={classes.basicInfoMain}
            >{`Work ID: ${lastWorkOrderName}`}</div>
            <div
              className={classes.basicInfoSub}
            >{`Last Updated: ${lastWorkOrderUpdatedDate}`}</div>
          </div>
        </div>
      </div>
      <AttributeDetails
        onPendingApproval={onAttributesPendingChange}
        asset={asset}
        onAttributeUpdate={onAttributesSave}
        loading={attributeLoading}
        canManageChanges={canManageChanges}
        canUpdate={canUpdate}
        view={AttributeView.MAP_TRAY}
        inputWidth="155px"
      />
    </div>
  );
};

export default AssetInfoTab;
